'use strict';

/**
 * click
 */
export const click = (() => {
    const $click = $('.js-click');

    /**
     * init
     */
    const init = () => {
        $click.on('click', () => {
            toggleClass($click);
        });
    };

    /**
     * toggleClass
     */
    const toggleClass = $element => {
        $element.toggleClass('is-clicked');
    };

    // public
    return {
        init: init
    };
})();
